// Centralized route configuration
import React from "react";
import RouteBoundary from "../components/RouteBoundary";
import ProjectList from "../components/project/ProjectList";
import ProjectObjectiveList from "../components/project-objective/ProjectObjectiveList";
import ProjectObjectiveViewOrchestrator from "../components/project-objective/ProjectObjectiveViewOrchestrator";
import ProjectQualStepDetails from "../components/project-qual-step/ProjectQualStepDetails";
import ProjectQualStepList from "../components/project-qual-step/ProjectQualStepList";
import ProjectPageDetails from "../components/project-page/ProjectPageDetails";
import ProjectPageList from "../components/project-page/ProjectPageList";
import ProjectPageComponentDetails from "../components/project-page-component/ProjectPageComponentDetails";
import ProjectPageComponentList from "../components/project-page-component/ProjectPageComponentList";
import Health from "../components/Health";
import Performance from "../components/performance";
import PerformanceOrchestrator from "../components/performance/PerformanceOrchestrator";
import Roster from "../components/roster";
import ProjectViewOrchestrator from "../components/project/ProjectViewOrchestrator";

export const routes = [
  {
    path: "/p",
    element: (
      <RouteBoundary>
        <ProjectList />
      </RouteBoundary>
    ),
  },
  {
    path: "/po",
    element: (
      <RouteBoundary>
        <ProjectObjectiveList />
      </RouteBoundary>
    ),
  },
  {
    path: "/pqs",
    element: (
      <RouteBoundary>
        <ProjectQualStepList />
      </RouteBoundary>
    ),
  },
  {
    path: "/pp",
    element: (
      <RouteBoundary>
        <ProjectPageList />
      </RouteBoundary>
    ),
  },
  {
    path: "/ppc",
    element: (
      <RouteBoundary>
        <ProjectPageComponentList />
      </RouteBoundary>
    ),
  },
  {
    path: "/p/:projectId",
    element: (
      <RouteBoundary>
        <ProjectViewOrchestrator />
      </RouteBoundary>
    ),
  },
  {
    path: "/po/:projectObjectiveId",
    element: (
      <RouteBoundary>
        <ProjectObjectiveViewOrchestrator />
      </RouteBoundary>
    ),
  },
  {
    path: "/pqs/:qualStepId",
    element: (
      <RouteBoundary>
        <ProjectQualStepDetails />
      </RouteBoundary>
    ),
  },
  {
    path: "/pp/:projectPageId",
    element: (
      <RouteBoundary>
        <ProjectPageDetails />
      </RouteBoundary>
    ),
  },
  {
    path: "/ppc/:projectPageComponentId",
    element: (
      <RouteBoundary>
        <ProjectPageComponentDetails />
      </RouteBoundary>
    ),
  },
  {
    path: "/performance",
    element: (
      <RouteBoundary>
        <Performance />
      </RouteBoundary>
    ),
  },
  {
    path: "/performance/report",
    element: (
      <RouteBoundary>
        <PerformanceOrchestrator />
      </RouteBoundary>
    ),
  },
  {
    path: "/roster",
    element: (
      <RouteBoundary>
        <Roster />
      </RouteBoundary>
    ),
  },
  {
    path: "/health",
    element: (
      <RouteBoundary>
        <Health />
      </RouteBoundary>
    ),
  },
];
